import { module } from 'modujs';
import ModelViewer from './ModelViewer'

export default class extends ModelViewer {
    constructor(m) {
        super(m);

        this.defaultAnimation = 'idle-1';
        this.models = this.getData('models').split(',');
    }

    init() {
        super.init()

        // ==========================================================================
        // TAP HANDLING
        // ==========================================================================
        let clickStartTime;
        let clickStartPos;
        this.onClickStart = (e) => {
            clickStartTime = Date.now();
            clickStartPos = {
                x: e.touches ? e.touches[0].screenX : e.screenX,
                y: e.touches ? e.touches[0].screenY : e.screenY,
            }

            this.interacting = true;
        }

        this.onClickEnd = (e) => {
            this.interacting = false;

            const deltaTime = Date.now() - clickStartTime

            const clickEndPos = {
                x: e.changedTouches ? e.changedTouches[0].screenX : e.screenX,
                y: e.changedTouches ? e.changedTouches[0].screenY : e.screenY,
            }
            let deltaPos = Math.abs(Math.sqrt(Math.pow(clickStartPos.x - clickEndPos.x, 2) + Math.pow(clickStartPos.y - clickEndPos.y, 2)))

            if(deltaTime < 250 && deltaPos < 10) {
                this.setModel(this.models[Math.floor(this.models.length * Math.random())]);
            }
        }

        this.el.addEventListener('pointerdown', this.onClickStart);
        this.el.addEventListener('pointerup', this.onClickEnd);
    }

    onInview(e) {
        if(e.target == this.el && e.way == 'enter') {
            this.setModel(this.models[Math.floor(this.models.length * Math.random())]);
        }
    }

    render() {
        super.render();

        if(!this.interacting) this.wrapper.rotation.set(0,this.wrapper.rotation.y + (0.02 * this.deltaTime/(1/60)),0)
    }

    initScene() {
        super.initScene();

        this.camera.position.set(1,3,5)
        this.controls.target.set(0, .9, 0)
        this.wrapper.scale.set(1.2,1.2,1.2);

        this.controls.maxPolarAngle = Math.PI * 0.60;
        this.controls.minPolarAngle = Math.PI * 0.30;

        this.controls.enableZoom = false;
        this.controls.enablePan = false;

        this.controls.touches = {}
        this.el.style.touchAction = ''; // enable touch scroll
    }

    destroy() {
        this.el.removeEventListener('pointerdown', this.onClickStart);
        this.el.removeEventListener('pointerup', this.onClickEnd);

        super.destroy();
    }
}
